import type { EnvironmentProviders } from '@angular/core';
import { APP_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { CONFIG } from '@config';

import { AuthService } from '../services/auth.service';
import { CookieService } from '../services/cookie.service';
import { PkceStorageService } from '../services/pkce-storage.service';
import { TokenService } from '../services/token.service';

const validateAuthConfig = (): void => {
  const required: (keyof typeof CONFIG.auth)[] = [
    'oktaTokenUrl',
    'oktaIntrospectUrl',
    'oktaClientId',
    'redirectUri',
    'oktaRedirectUri',
    'webAuthSignInUrl',
  ];

  required.forEach((key) => {
    if (CONFIG.auth[key] === undefined || CONFIG.auth[key] === null) {
      console.error(`[Auth] Missing required config field: auth.${key}`);
    }
  });
};

export const provideAuth = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    CookieService,
    PkceStorageService,
    TokenService,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => {
        validateAuthConfig();

        return () => authService.handleAuthCallback();
      },
      deps: [AuthService],
      multi: true,
    },
  ]);
